// Employee roles from backend
export type EmployeeRole = 
  | 'SUPER_ADMIN'
  | 'ADMINISTRATOR'
  | 'PRODUCTION_CONTROLLER'
  | 'SALESMAN'
  | 'RECEPTION'
  | 'JACKET_MAKER'
  | 'SHIRT_MAKER'
  | 'TROUSER_MAKER'
  | 'ALTERATION'
  | 'MASTER';

// Login allowed roles
export const LOGIN_ALLOWED_ROLES: EmployeeRole[] = [
  'SUPER_ADMIN',
  'ADMINISTRATOR',
  'PRODUCTION_CONTROLLER',
  'SALESMAN',
  'RECEPTION'
];



// Role-based menu access
export interface MenuAccess {
  dashboard: boolean;
  employees: boolean;
  customers: boolean;
  measurements: boolean;
  orders: boolean;
  workflows: boolean;
  reports: boolean;
  settings: boolean;
}

// User interface matching backend response
export interface User {
  id: string;
  username: string;
  fullName: string;
  designation: EmployeeRole;
  contactNumber: string;
  email?: string;
  profilePicture?: string;
  branchId: string;
  branchName: string;
  assignedBranchIds: string[];
  allowLogin: boolean;
  isActive: boolean;
  isAdmin?: boolean;
  isSuperAdmin?: boolean;
}

// Authentication response from API
export interface AuthResponse {
  success: boolean;
  message: string;
  data: {
    user: User;
    accessToken: string;
    refreshToken: string;
  };
}

// Login request
export interface LoginRequest {
  username: string;
  password: string;
  rememberMe?: boolean;
}

// Auth context state
export interface AuthState {
  user: User | null;
  accessToken: string | null;
  refreshToken: string | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  error: string | null;
}

// Auth context actions
export interface AuthActions {
  login: (credentials: LoginRequest) => Promise<void>;
  logout: () => void;
  refreshAuthToken: () => Promise<void>;
  clearError: () => void;
  checkAuth: () => Promise<void>;
  getMenuAccess: () => MenuAccess | null;
}

// Complete auth context type
export interface AuthContextType extends AuthState, AuthActions {}

// Token storage keys
export const TOKEN_KEYS = {
  ACCESS_TOKEN: 'tailortrack_access_token',
  REFRESH_TOKEN: 'tailortrack_refresh_token',
  REMEMBER_ME: 'tailortrack_remember_me',
  USER_DATA: 'tailortrack_user_data'
} as const;

// Remember me duration (2 days in milliseconds)
export const REMEMBER_ME_DURATION = 2 * 24 * 60 * 60 * 1000; // 2 days
